import { FC } from "react";
import Skeleton from "react-loading-skeleton";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { Shelf } from "../../layout";
import { Body } from "../../typography";
import styles from "./styles.module.scss";

/**
 * The `SharedRadioPlaceholder` component properties.
 */

export interface SharedRadioPlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `SharedRadio` component.
 */
export const SharedRadioPlaceholder: FC<SharedRadioPlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.SharedRadioPlaceholder, "shared-radio", "placeholder"],
    testIdPrefix: "shared-radio",
  });

  return (
    <Body {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <Shelf spacing="small" alignment="top">
        <div className="dot">
          <Skeleton />
        </div>
        <div className="label">
          <Skeleton />
        </div>
      </Shelf>
    </Body>
  );
};
